import { useSyncExternalStore } from "react";
import {
  isShortcutsHelpOpen,
  setShortcutsHelpOpen,
  subscribeShortcutsHelp,
} from "@/shared/lib/shortcutsHelp";

export interface ShortcutsHelpControls {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

/** Open state of the keyboard-shortcuts help overlay + controls to drive it. */
export function useShortcutsHelp(): ShortcutsHelpControls {
  const open = useSyncExternalStore(
    subscribeShortcutsHelp,
    isShortcutsHelpOpen,
    isShortcutsHelpOpen,
  );
  return {
    open,
    setOpen: setShortcutsHelpOpen,
    toggle: () => setShortcutsHelpOpen(!isShortcutsHelpOpen()),
  };
}
